<template>
  <div class="py-4 container-fluid w-75">
    <div class="row btnRow">
      <button
        @click="() => this.$router.push({ path: 'dashboard-default' })"
        class="routerHomeLink"
        to="/dashboard-default"
      >
        Back To Evo Apps
      </button>
    </div>
    <div class="row">
      <div class="col-12">
        <PersonalInfoContainer />
      </div>
    </div>
    <div class="mt-4 row">
      <div class="col-12">
        <DataSubscriptionContainer />
      </div>
    </div>
    <div class="mt-4 row">
      <div class="col-12">
        <SecurityContainer />
      </div>
    </div>
  </div>
</template>

<style scoped>
.routerHomeLink {
  display: flex;
  align-items: center;
  width: 200px;
  font-size: 1.2rem;
  padding: 0 0.75em;
  height: 50px;
  font-weight: bold;
  transition: all 0.2s ease-in-out;
  border: none;
  justify-content: center;
  background-color: #23272b;
  color: #fff;
  border-radius: 0.25rem;
}
.routerHomeLink:hover {
  background-color: rgb(94, 224, 241);
  box-shadow: 0 5px 12px rgb(94, 224, 241);
  border-radius: 0.25rem;

  color: black;
}

.btnRow {
  justify-content: center;
  margin-bottom: 20px;
}
</style>
<script>
import {
  PersonalInfoContainer,
  DataSubscriptionContainer,
  SecurityContainer,
} from "./containers/exporter.js";
import { mapGetters } from "vuex";

export default {
  name: "profile",
  components: {
    PersonalInfoContainer,
    DataSubscriptionContainer,
    SecurityContainer,
  },
  computed: mapGetters(["getIsLogined"]),
  mounted() {
    window.document.title = "Evolution";
  },
};
</script>
